<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="intro"><span><span class="line"><a href="#/Contents#int">INTRODUCTION</a></span></span></h2>
<p class="noindent"><span><a id="page_x">Finally.</a></span></p><a id="page_x">
<p class="indent"><span>We’re finally there, yet again. The end of a fascinating journey and the culmination of our efforts as we finish a new book. It all comes down to (complete exhaustion?)—the introduction.</span></p>
<p class="indent"><span>Three years ago we created our very first <i>Uncle John’s Bathroom Reader Plunges Into History</i> (dare we call it a historic event?), and now we’re very proud to present its creatively titled offspring <i>Uncle John’s Bathroom Reader Plunges Into History Again.</i></span></p>
<p class="indent"><span>Anyway, in compiling our first book, we discovered that we had so many great stories, anecdotes, and tidbits that we couldn’t squeeze them all in. It was an embarrassment of riches, if you know what I mean. Take a look at some of these gems and see what I’m talking about:</span></p>
<table cellpadding="0" cellspacing="0" class="tab">
<tbody>
<tr>
<td align="left">Typhoid Mary Quite Contrary</td>
<td align="left" style="padding-left:1.5em;">Chanel No. 1</td>
</tr>
<tr>
<td align="left">The Real M*A*S*H</td>
<td align="left" style="padding-left:1.5em;">Move Over Babe Ruth</td>
</tr>
<tr>
<td align="left">Let’s Go to Greenland</td>
<td align="left" style="padding-left:1.5em;">The Coolest Man in History</td>
</tr>
<tr>
<td align="left">Mona Lisa Caper</td>
<td align="left" style="padding-left:1.5em;">Carbine Williams</td>
</tr>
<tr>
<td align="left">The Mighty Pen</td>
<td align="left" style="padding-left:1.5em;">The Queen’s Dwarf</td>
</tr>
</tbody>
</table>
<p class="noindenta"><span>So we decided to create this book. We couldn’t just let this great material fall through the cracks, could we? We hope you enjoy reading this as much as we did writing it for you.</span></p>
<p class="indent"><span>So…bring your seatbacks to their full and upright or comfortably reclined positions. Make sure that those trays are up and locked, please turn off all electronic devices, and get ready for another fascinating, fun, and factual journey through time in <i>Uncle John’s Bathroom Reader Plunges Into History Again.</i></span></p>
<p class="indent"><span>And speaking of time—it’s getting late. We have other books to finish and start, and we all want to go home.</span></p>
<p class="indent"><span>Enjoy!</span></p>
<p class="indent"><span>Remember to always go with the flow,</span></p>
<p class="right"><span><b>—Uncle John and the BRI Staff</b></span></p>
</a><p class="noindent"><a id="page_x"><span>P.F. (Post Flush) Visit our Web site at </span></a><a href="http://www.bathroomreaders.com" target="_blank">www.BathroomReaders.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?7eb04b42